import { Pipe, PipeTransform } from '@angular/core';
import Decimal from 'decimal.js';

@Pipe({
  name: 'decimalAmount'
})
export class DecimalAmountPipe implements PipeTransform {

  transform(value: any): string | null {
    if(!value){
      return null;
    }
      return new Decimal(value).toFixed(2);
  }

}
